let mobx = require('mobx');
// create State object
let data = {
    weeks: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
    tempWorkTime:{},
}
let cancelOrderState = mobx.observable(data);

// export default loginState;
module.exports = cancelOrderState;